import React, { RefObject, useState } from 'react';
import { Tooltip } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import Fade from '@mui/material/Fade';
import { useMountEffect } from '../../globals/hooks/use-mount-effect';
import { throttle } from '../../globals/utils';

const TableHoverTooltip = ({ containerReference }: { containerReference: RefObject<any> }) => {
  const [toolTipContent, setTooltipContent] = useState<
    { x: number; y: number; content: string } | undefined
  >();

  const saveElementInformation = (event: any) => {
    const { target } = event;
    if (
      target &&
      (target.tagName === 'TD' || target.tagName === 'H6') &&
      target.scrollWidth > target.clientWidth
    ) {
      const rect = target.getBoundingClientRect();
      setTooltipContent({
        y: rect.top + window.scrollY + rect.height / 2,
        x: rect.right + window.scrollX - rect.width + 10,
        content: target.textContent || '',
      });
    }
  };

  const throttleAndReset = (event: any) => {
    if (toolTipContent !== event.target.textContent) setTooltipContent(undefined);
    throttle(() => saveElementInformation(event), containerReference, 500);
  };

  useMountEffect(() => {
    containerReference?.current?.addEventListener('mouseover', throttleAndReset);
    return () => {
      containerReference?.current?.removeEventListener('mouseover', throttleAndReset);
    };
  });
  const CustomTooltip = withStyles({ tooltip: { fontSize: '13px' } })(Tooltip);

  return (
    <>
      <CustomTooltip
        open={!!toolTipContent}
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 600 }}
        title={`${toolTipContent?.content}`}
        placement="top-start"
        arrow
      >
        <div
          style={{
            position: 'absolute',
            top: toolTipContent?.y || 0,
            left: toolTipContent?.x || 0,
          }}
        />
      </CustomTooltip>
    </>
  );
};

export default TableHoverTooltip;
